angular.module('unica_approvation_list.approvation_list_controllers', [])

.controller('ApprovationListBasicController',
	function(
		$rootScope, $scope,
		UserListService
	) {

	$scope.forms = {};


	/**
	 * FUNCTIONS FOR AUTOCOMPLETE ZONE MANAGERS
	 */

	$scope.searchZmText = '';

	$scope.searchZoneManager = function(query) {
		return UserListService
					.listByRoleAndSearch( 'zone_manager', 'zone_manager', query)
					.then(function(users) {
						if ( users ) {
							return users;
						}

						return [];
					});
	};

	$scope.selectedZm = function(zm) {
		$scope.approvationListData.user_id = ( zm ? zm.id : null );
	};





	/**
	 * FUNCTIONS FOR AUTOCOMPLETE AREA MANAGERS
	 */

	$scope.searchAmText = '';

	$scope.searchAreaManager = function(query) {
		return UserListService
					.listByRoleAndSearch( 'area_manager', 'area_manager', query)
					.then(function(users) {
						if ( users ) {
							return users;
						}

						return [];
					});
	};

	$scope.selectedAm = function(am) {
		$scope.approvationListData.list_checker_id = ( am ? am.id : null );
	};

});


